import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize, spacing, breakpoints } = redesignTheme;

export const usePageHeaderStyles = makeStyles(() => ({
  headerBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.xs,
    marginBottom: spacing.md,
  },
  backButton: {
    display: 'inline-flex',
    alignItems: 'center',
    alignSelf: 'flex-start',
    gap: 4,
    margin: 0,
    padding: 0,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.text,
    lineHeight: 'normal',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  pageTitle: {
    margin: 0,
    fontFamily: fonts.gothicBold,
    fontSize: fontSize.xxl,
    color: colors.text,
    lineHeight: 'normal',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.xl,
    },
  },
  pageTitlePrimary: {
    fontFamily: fonts.gothicSemiBold,
    color: colors.primaryDark,
  },
  pageDescription: {
    margin: 0,
    maxWidth: 864,
    fontFamily: fonts.opensans,
    fontSize: fontSize.intro,
    color: colors.text,
    lineHeight: 'normal',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.base,
    },
  },
  pageDescriptionWide: {
    maxWidth: 940,
  },
  pageDescriptionBrown: {
    color: colors.brownDark,
  },
  pageHeaderRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      gap: 64,
    },
  },
  pageHeaderText: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.xs,
  },
  pageHeaderContent: {
    minWidth: 0,
  },
  pageHeaderActions: {
    width: 'fit-content',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    alignSelf: 'flex-end',
    [`@media (max-width: ${breakpoints.tablet - 1}px)`]: {
      alignSelf: 'stretch',
      width: '100%',
    },
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      marginLeft: 'auto',
      flexShrink: 0,
    },
  },
  headerSearch: {
    width: 352,
    maxWidth: '100%',
    [`@media (max-width: ${breakpoints.tablet - 1}px)`]: {
      width: '100%',
    },
  },
}));
